export const LIST_TYPES: string[] = ['numbered-list', 'bulleted-list'];
export const TEXT_ALIGN_TYPES: string[] = ['left', 'center', 'right', 'justify'];
